
<template>
  <v-app id="onIndi">
    <v-main>
    <v-container fluid>  
    <v-card>
      
      Nr: {{indi.indi_nr}}  

      <span v-for="(inditaalRecord,i) in indi.inditaal" :key="i">
       <br>
       {{inditaalRecord.taal_code}}  <v-btn class="primary ma-2" small @click="saveInditaal(inditaalRecord)">Save</v-btn><br>
       <v-textarea v-model="inditaalRecord.inditaal_oms" :value=inditaalRecord.inditaal_oms rows="1" label="Translation" spellcheck="false"></v-textarea>
       <br>
      </span>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  props: ['indi_encrid'],
  data() {
    return {
      indi: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/indi/getIndi.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getIndi"
          },
          getIndi: {
             indi_encrid: this.indi_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.indi = res.data.getIndi;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    saveInditaal(inditaal) { 
      this.$axios
        .post("ares/json/ares/syst/ref/indi/saveInditaal.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveInditaal"
          },
          saveInditaal: {
            inditaal: inditaal
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveInditaal.text,
              color: res.data.saveInditaal.color
            });
          }
        })
    }
  }  

};

</script> 
